<template>
  <div class="fill-height">
    <v-card flat>
      <v-card-title class="py-0 px-1">
        <v-toolbar
          :height="$vuetify.breakpoint.xsOnly ? 44 : 60"
          class="filter-toolbar"
          flat
        >
          <v-spacer />

          <filter-search v-model="dataTable.search.terms" />

          <filter-options
            v-model="filtersModel"
            :filters="filterData"
          />
        </v-toolbar>
      </v-card-title>

      <v-container
        class="pa-0"
        fluid
      >
        <v-row>
          <v-col cols="12">
            <v-data-table
              :footer-props="dataTable.footerProps"
              :headers="dataTableHeaders"
              :height="dataTable.resize.bodyHeight"
              :items="dataTable.data"
              :loading="dataTable.loading"
              :loading-text="dataTable.text.loadingText"
              :no-data-text="dataTable.text.noDataText"
              :no-results-text="dataTable.text.noResultsText"
              :options.sync="dataTable.options"
              :search="dataTable.search.terms"
              :server-items-length="dataTable.total"
              fixed-header
              item-key="Id"
            >
              <template #[`item.id`]="{item}">
                {{ item.Id }}
              </template>

              <template #[`item.log_name`]="{item}">
                <status-chip
                  :chip-style="{cursor: 'pointer'}"
                  :color="item.NameColor"
                  :icon="item.NameIcon"
                  :label="item.NameTitle"
                  dense
                  use-contrast-color
                  @click="getItemDetails(item)"
                />
              </template>

              <template #[`item.description`]="{item}">
                {{ item.Description }}
              </template>

              <template #[`item.subject_type`]="{item}">
                {{ item.SubjectName }}
              </template>

              <template #[`item.user`]="{item}">
                <div v-if="item.User">
                  {{ item.User }}
                </div>

                <div
                  v-if="item.Username"
                  class="grey--text"
                >
                  {{ item.Username }}
                </div>
              </template>

              <template #[`item.ip_address`]="{item}">
                <v-btn
                  v-if="!!item.IPAddress"
                  :href="`https://ipinfo.io/${item.IPAddress}`"
                  class="px-1"
                  color="info"
                  small
                  target="_blank"
                  text
                >
                  {{ item.IPAddress }}
                </v-btn>
              </template>

              <template #[`item.user_agent`]="{item}">
                <div style="font-size: 9px; line-height: 11px !important;">
                  {{ item.UserAgent }}
                </div>
              </template>

              <template #[`item.created_at`]="{item}">
                <div class="text-no-wrap">
                  {{ item.CreatedAt }}
                </div>
              </template>

              <template #[`item.actions`]="{item}">
                <v-btn
                  :class="$t('Log.Table.Button.View.Color')"
                  :small="$vuetify.breakpoint.xsOnly"
                  class="ma-0 ml-1"
                  dark
                  icon
                  @click="getItemDetails(item)"
                >
                  <v-icon :small="$vuetify.breakpoint.xsOnly">
                    {{ $t('Log.Table.Button.View.Icon') }}
                  </v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <activity-log-dialog
      :item="selectedItem"
      :visible.sync="detailsDialogVisible"
    />
  </div>
</template>

<script>
import Auth from '@/mixins/auth'
import AppData from '@/mixins/appdata'
import DataTable from '@/mixins/data-table/dataTable'
import FilterCommon from '@/mixins/filter/filterCommon'
import FilterSearch from '@/components/common/filter/FilterSearch'
import FilterOptions from '@/components/common/filter/FilterOptions'
import StatusChip from '@/components/common/StatusChip.vue'
import ActivityLogDialog from '@/components/activity-log/ActivityLogDialog.vue'

export default {
  name      : 'ActivityLog',
  components: {
    ActivityLogDialog,
    StatusChip,
    FilterSearch,
    FilterOptions
  },
  directives: {},
  mixins    : [AppData, Auth, DataTable, FilterCommon],
  props     : {},
  data() {
    return {
      selectedItem        : null,
      detailsDialogVisible: false,
      filtersModel        : {
        lang        : 'Log.Table',
        filterAction: {
          key  : 'filter_action',
          value: null,
          items: []
        },
        filterUser: {
          key  : 'filter_user',
          value: null,
          items: []
        },
        filterDate: {
          key    : 'filter_date',
          value  : null,
          visible: false,
          date   : null
        }
      },
      dataTable: {
        dataStore    : null,
        socketCommand: {
          list: window.SocketCommand.ActivityLog.All
        },
        options: {
          defaultSortBy: 'created_at',
          sortBy       : ['created_at'],
          sortDesc     : [true]
        },
        rejectHeaders: {
          xsOnly   : [],
          smAndDown: [],
          mdAndDown: [],
          lgAndDown: [],
          xlAndDown: []
        },
        headers: [
          {
            text     : this.$t('Log.Table.Headers.Id'),
            value    : 'id',
            align    : 'right',
            sortable : true,
            cellClass: 'text-caption'
          },
          {
            text     : this.$t('Log.Table.Headers.Name'),
            value    : 'log_name',
            align    : 'left',
            sortable : true,
            cellClass: 'text-caption'
          },
          {
            text     : this.$t('Log.Table.Headers.Description'),
            value    : 'description',
            align    : 'left',
            sortable : true,
            cellClass: 'text-caption'
          },
          {
            text     : this.$t('Log.Table.Headers.SubjectName'),
            value    : 'subject_type',
            align    : 'left',
            sortable : true,
            cellClass: 'text-caption'
          },
          {
            text     : this.$t('Log.Table.Headers.User'),
            value    : 'user',
            align    : 'left',
            sortable : false,
            cellClass: 'text-caption'
          },
          {
            text     : this.$t('Log.Table.Headers.IpAddress'),
            value    : 'ip_address',
            align    : 'left',
            sortable : false,
            cellClass: 'text-caption'
          },
          {
            text     : this.$t('Log.Table.Headers.UserAgent'),
            value    : 'user_agent',
            align    : 'left',
            sortable : true,
            cellClass: 'text-caption',
            width    : 300
          },
          {
            text     : this.$t('Log.Table.Headers.Date'),
            value    : 'created_at',
            align    : 'center',
            sortable : true,
            cellClass: 'text-caption'
          },
          {
            text     : this.$t('Log.Table.Headers.Actions'),
            value    : 'actions',
            align    : 'right',
            sortable : false,
            cellClass: 'text-caption px-2',
            width    : '50px'
          }
        ]
      }
    }
  },
  computed: {},
  watch   : {},
  created() {
    this.$bus.$on(window.SocketCommand.ActivityLog.AllFilters, this.onFiltersDataResponse)

    this.getFiltersData()

    // Init Custom Filter Values
    // this.filtersModel.filterAction.items = this.filterTypeItems
  },
  mounted() {
  },
  updated() {
  },
  beforeDestroy() {
    this.$bus.$off(window.SocketCommand.ActivityLog.AllFilters, this.onFiltersDataResponse)
  },
  methods: {
    getItemDetails(item) {
      this.selectedItem = item
      this.detailsDialogVisible = true
    },

    getFiltersData() {
      window.callAS(window.SocketCommand.ActivityLog.AllFilters, {})
    },
    onFiltersDataResponse(data) {
      this.filtersModel.filterAction.items = data?.Actions || []
      this.filtersModel.filterUser.items = data?.Users || []
    }
  }
}
</script>

<style scoped>

</style>
